import React, { useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { apiCall } from "../../utils/apiService";
import MessageHeaderLayer from "./MessageHeaderLayer";
import CodeSamplesPanel from "./CodeSamplesPanel";
import "./ApiTestPage.css";

const ContactLayer = () => {
  const [alertMessage, setAlertMessage] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [data, setData] = useState({
    client_id: null,
    token: null,
    mobile: "",
    name: "",
    phone: "",
    type: "contact",
  });

  const hideAlert = (sec = 1) => {
    setTimeout(() => {
      setAlertMessage("");
      setSpinner(false);
    }, sec * 1000);
  };

  const validated = () => {
    if (!data.client_id) return { isValid: false, messageText: "Instance is required!" };
    if (!data.token) return { isValid: false, messageText: "Token is required!" };
    if (!data.mobile) return { isValid: false, messageText: "Phone is required!" };
    if (!data.name) return { isValid: false, messageText: "Contact name is required!" };
    if (!data.phone) return { isValid: false, messageText: "Contact number is required!" };
    return { isValid: true, messageText: "" };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { isValid, messageText } = validated();
    if (!isValid) {
      setAlertMessage({ message: messageText, class: "danger" });
      hideAlert(2);
      return;
    }

    setSpinner(true);
    try {
      const formData = new FormData();
      for (let key in data) {
        if (data[key] != null) formData.append(key, data[key]);
      }
      const response = await apiCall({
        url: "send-message/send-contact",
        method: "POST",
        body: formData,
        withoutStringify: true,
      });

      setAlertMessage({
        message: response.msg,
        class: response.success ? "success" : "danger",
      });
      hideAlert(2);
    } catch (error) {
      setAlertMessage({ message: error.message, class: "danger" });
      hideAlert(2);
    }
  };

  useEffect(() => {
    document.title = "Send Contact";
  }, []);

  const sampleParams = useMemo(
    () => ({
      clientId: data.client_id,
      token: data.token,
      mobile: data.mobile,
      contactName: data.name,
      contactPhone: data.phone,
    }),
    [data.client_id, data.token, data.mobile, data.name, data.phone]
  );

  return (
    <div className="api-test-page">
      <div className="card">
        <div className="card-body">
          <div className="api-test-welcome">
            <div>
              <h5>Contact message test</h5>
              <p>Share a WhatsApp contact card and copy API samples for send-contact.</p>
            </div>
            <span className="api-test-badge">
              <Icon icon="mdi:api" width={14} />
              POST · Contact
            </span>
          </div>

          <MessageHeaderLayer
            getHeaderData={(id, apiKey) =>
              setData((prev) => ({ ...prev, client_id: id || null, token: apiKey }))
            }
          />

          <div className="api-test-grid">
            <form className="api-test-card" onSubmit={handleSubmit}>
              <div className="api-test-card-head">
                <h6>Request test</h6>
                <span>vCard send</span>
              </div>
              <div className="api-test-card-body">
                <div className="api-test-note">
                  <Icon icon="mdi:information-outline" width={18} />
                  <span>Use it wisely — not recommended for bulk numbers from this tester.</span>
                </div>

                {alertMessage && (
                  <div className={`api-test-alert ${alertMessage.class}`}>{alertMessage.message}</div>
                )}

                <label className="api-test-label" htmlFor="contact-to">
                  Recipient phone
                </label>
                <input
                  id="contact-to"
                  type="text"
                  className="form-control"
                  placeholder="923037900571"
                  value={data.mobile || ""}
                  onChange={(e) => setData({ ...data, mobile: e.target.value })}
                />
                <span className="api-test-help">Mobile number with country code, without +</span>

                <label className="api-test-label" htmlFor="contact-name">
                  Contact name
                </label>
                <input
                  id="contact-name"
                  type="text"
                  className="form-control mb-3"
                  placeholder="Contact Name"
                  value={data.name || ""}
                  onChange={(e) => setData({ ...data, name: e.target.value })}
                />

                <label className="api-test-label" htmlFor="contact-phone">
                  Contact number
                </label>
                <input
                  id="contact-phone"
                  type="text"
                  className="form-control"
                  placeholder="Contact Number"
                  value={data.phone || ""}
                  onChange={(e) => setData({ ...data, phone: e.target.value })}
                />

                <div className="api-test-actions">
                  <button type="submit" className="btn api-test-submit" disabled={spinner}>
                    {spinner ? "Sending…" : "Send Contact"}
                  </button>
                </div>
              </div>
            </form>

            <CodeSamplesPanel kind="contact" params={sampleParams} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactLayer;
